import { safeDefine } from "@breuni-ui/safe-define";
import { CarouselNavigationPrev } from "@breuni-ui/carousel";

export default class EntdCarouselNaviPrev extends CarouselNavigationPrev {}
safeDefine("entd-carousel-navi-prev", EntdCarouselNaviPrev);
